
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import apiClient from '@/app/clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import { ToastType } from '@/lib/components/toast/types';
import logger from '@/app/logger';
import TInput from '@/lib/form/input/Input.vue';
declare let PARTNER_MODE: boolean;
declare let PARTNER_ID: string;

@Component({
  name: 'verify-top',
  components: {
    TButton,
    TInput
  },
  props: ['mode', 'context']
})
export default class VerifyOtp extends Vue {
  private context!: any;
  private genericLoader = false;
  private resendLink = false;
  private partnerMode = PARTNER_MODE;
  private partnerId = PARTNER_ID;
  otp = '';
  invalidOTP = false;
  mode!: string;
  private attributions = {};
  private isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  mounted() {
    window.setTimeout(() => {
      this.resendLink = true;
    }, 150 * 100);
  }

  get heading() {
    return this.$t('onboard.register.email_sign_up.verify_otp_desc');
  }

  get cta() {
    if (this.mode == 'signup') {
      return this.$t('onboard.register.email_sign_up.verify_otp_cta_signup');
    } else if (this.context.targetFlow == 'reset_password') {
      return this.$t('onboard.register.email_sign_up.verify_otp_cta_reset');
    } else if (this.context.targetFlow == 'set_password') {
      return this.$t('onboard.register.email_sign_up.verify_otp_cta_set');
    }
  }

  get description() {
    if (this.mode == 'signup') {
      return this.$t(
        'onboard.register.email_sign_up.set_password_veriy_otp_signup_desc'
      );
    } else if (this.context.targetFlow == 'reset_password') {
      return this.$t(
        'onboard.register.email_sign_up.reset_password_veriy_otp_desc'
      );
    } else if (this.context.targetFlow == 'set_password') {
      return this.$t(
        'onboard.register.email_sign_up.set_password_veriy_otp_desc'
      );
    }
  }

  get email() {
    return this.context.email;
  }

  next() {
    if (!this.otp) {
      this.invalidOTP = true;
      return;
    }
    this.genericLoader = true;
    apiClient
      .verifyOtp(this.email, this.otp, this.attributions)
      .then(data => {
        this.$emit('update', {
          flowType: this.context.targetFlow,
          data: {
            email: this.email,
            targetFlow: this.mode == 'signup' ? 'profile_setup' : 'login',
            authToken: data.auth_jwt_token
          }
        });
        this.genericLoader = false;
      })
      .catch(e => {
        this.genericLoader = false;
        this.$error(e);
      });
  }

  resendOtp() {
    this.genericLoader = true;
    apiClient
      .sendOTP(this.email)
      .then(data => {
        this.genericLoader = false;
        this.$success(this.$t('onboard.register.email_sign_up.otp_sent'));
      })
      .catch(error => {
        this.genericLoader = false;
        this.$error(error);
      });
  }
}
